export default "__VITE_ASSET__C06_D8T$__"